export default __webpack_public_path__ + "static/media/promos.3ed867f0.svg";